import { apiRequest } from "../util/apiUtils";

export const orderList = async (params) => {
  try {
    const res = await apiRequest("get", `order/my-order`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const orderDetails = async (params) => {
  try {
    const res = await apiRequest("get", `/order/my-order-details`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};
export const changeStatus = async (payload = {}) => {
  try {
    const res = await apiRequest("patch", `/order/status-change`, {
      body: payload,
    });
    return res?.data;
  } catch (err) {
    throw err;
  }
};
